import { IBaseAction } from '@bimser/core';
import * as ActionTypes from '../actions/actionTypes';
import { HubConnectionState, HubConnectionStateFactory } from '../entities';

export default function (
	state: HubConnectionState = HubConnectionStateFactory(),
	action: IBaseAction<any>
): HubConnectionState {
	let result: HubConnectionState;

	switch (action.type) {
		case ActionTypes.SET_DEVICE_TAB_ID:
			result = setDeviceTabId(state, action);
			break;
		default:
			result = state;
	}

	return result;
}

function setDeviceTabId(state: HubConnectionState, action: IBaseAction<any>): HubConnectionState {
	const deviceTabId: string = action.payload;
	return state.setIn(['deviceTabId'], deviceTabId);
}
